import React, { useRef, useState } from "react";
import { constants } from "../../utils/constants";

const VideoModal = ({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: () => void;
}) => {
  const youtubeRef = useRef<any>(null);

  const closeVideo = () => {
    onClose();
    console.log(youtubeRef, 'TEST')
  };

  const handleClickOutside = (e: any) => {
    if (e.target === e.currentTarget) {
      closeVideo();
    }
  };

  return (
    <>
      {isVisible && (
        <div
          className="z-[1000] bg-[rgba(0,0,0,0.85)] flex-col justify-center items-center fixed p-[100px] inset-[0%]"
          style={{ display: isVisible ? "flex" : "none" }}
          onClick={handleClickOutside}
        >
          <div className="aspect-[1722/973] w-80 flex-col sm:w-3/5 sm:flex-row items-start flex relative">
            <div
              className="text-[#f1d8a7] cursor-pointer text-4xl absolute ml-[18px] -mr-5 sm:-mr-9 left-auto bottom-auto top-[-44px] sm:top-[-30px] right-5 sm:-right-10"
              onClick={closeVideo}
            >
              ✖
            </div>
            <div
              style={{ paddingTop: "56.17021276595745%" }}
              className="w-full bg-[url('../images/general/embeddedVideoBg.svg')] bg-[50%] bg-cover relative pb-0 px-0 h-full max-h-full"
            >
              <iframe
                ref={youtubeRef}
                src={constants.youtube_intro}
                frameBorder="0"
                className="absolute w-full h-full pointer-events-auto left-0 top-0"
                allow="encrypted-media"
                allowFullScreen
                title="How to play #MedievalEmpires"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoModal;
